// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-error[data-v-6f6d6a42] {\n  border: 1px solid red;\n}\n.error-text[data-v-6f6d6a42] {\n  color: red;\n  font-size: 12px;\n  margin-left: 5px;\n}\n.warning-text[data-v-6f6d6a42] {\n  color: #ffba00;\n  display: inline-block;\n}\n.dialog .contract-tag[data-v-6f6d6a42] {\n  position: absolute;\n  right: 0;\n  top: 70px;\n}\n.el-icon-plus[data-v-6f6d6a42] {\n  float: right;\n  margin-top: 8px;\n}", ""]);
// Exports
module.exports = exports;
